// 一个vue3插件，用于注册全局使用的组件和指令
import Dialog from '@/components/dialog.vue';
import click from '@/plugins/vue/click';
import show from '@/plugins/vue/show';
import Image from '@/components/Image.vue';
import Button from '@/components/Button.vue';
import Account from '@/components/account.vue';
import ruleBtn from '@/components/ruleBtn.vue';
import shareBtn from '../../components/shareBtn.vue';
import joinBtn from '../../components/joinBtn.vue';
import itemContainer from '@/components/itemContainer.vue';
import Header from '../../components/Header.vue';
// import ParticleDialog from '@/components/ParticleDialog.vue';
// 添加全局函数
import record from '@/utils/log';
const plugin = {
  install(app) {
    app.component('TxDialog', Dialog);
    app.component('TxImage', Image);
    app.component('TxButton', Button);
    app.component('TxAccount', Account);
    app.component('TxRule', ruleBtn);
    app.component('TxShare', shareBtn);
    app.component('TxJoin', joinBtn);
    app.component('TxContainer', itemContainer);
    app.component('TxHeader', Header);
    // app.component('TxParticleDialog', ParticleDialog);
    app.directive('click', click);
    app.directive('look', show);
    app.config.errorHandler = (err, instance, info) => {
      if (import.meta.env.PROD) {
        record({
          name: import.meta.env.VITE_NAME,
          message: err.message,
          stack: err.stack ? err.stack : '',
          instance: instance.$options.name,
          info,
        });
      } else {
        console.error('报错:', err, instance, info);
      }
    };
  },
};

export default plugin;
